import ArrowRight from "remixicon-react/ArrowRightSLineIcon";

export function GoToHotspotCardButton() {
  return (
    <ArrowRight
      size={16}
      style={{ transform: "translate(-0%,-50%)", position: "relative" }}
    />
  );
}
